import React from "react";
import { Globe, ShieldAlert, Cpu, Database, Activity, ExternalLink } from "lucide-react";

interface HeaderProps {
  entityCount: number;
  eventCount: number;
  activeLayerCount: number;
  asOfPeriod: string;
}

export const Header: React.FC<HeaderProps> = ({
  entityCount,
  eventCount,
  activeLayerCount,
  asOfPeriod,
}) => {
  return (
    <header className="cc-header">
      <div className="brand-section">
        <div className="brand-logo">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{
              width: "24px",
              height: "24px",
              borderRadius: "4px",
              background: "linear-gradient(135deg, #6366f1 0%, #06b6d4 100%)",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 10px rgba(99, 102, 241, 0.4)"
            }}>
              <Globe size={15} color="#ffffff" />
            </span>
            <span className="nexus-title">NEXUS</span>
            <span style={{ opacity: 0.3 }}>/</span>
            <span className="nexus-sub">TECHNOLOGICAL POWER</span>
          </div>
        </div>

        <div className="badge-period">
          <span style={{ opacity: 0.7 }}>PERIOD:</span> {asOfPeriod}
        </div>

        <span className="disclaimer-text">
          2026-H1 SYNTHETIC SNAPSHOT · Prototype / Synthetic dataset · Not a real-time intelligence service
        </span>
      </div>

      <div className="header-status-pills">
        <a className="hud-pill font-mono" href="https://ftners-nexus.nexus-api.workers.dev/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <span>FTNERS</span>
          <ExternalLink size={11} />
        </a>

        <a className="hud-pill font-mono" href="https://b2w-hub.pages.dev/" target="_blank" rel="noreferrer" style={{ textDecoration: "none" }}>
          <span>B2W</span>
          <ExternalLink size={11} />
        </a>

        <div className="hud-pill font-mono">
          <Database size={13} color="#06b6d4" />
          <span>ENTITIES: <strong style={{ color: "#f1f5f9" }}>{entityCount}</strong></span>
        </div>

        <div className="hud-pill font-mono">
          <Activity size={13} color="#6366f1" />
          <span>EVENTS: <strong style={{ color: "#f1f5f9" }}>{eventCount}</strong></span>
        </div>

        <div className="hud-pill font-mono">
          <Cpu size={13} color="#10b981" />
          <span>LAYERS: <strong style={{ color: "#f1f5f9" }}>{activeLayerCount}/6</strong></span>
        </div>

        {/* Mandatory un-hideable MOCK DATA badge */}
        <div className="badge-mock" title="Notice: All index values, assessments, and citations in V0 are synthetic fixtures for demonstration.">
          <ShieldAlert size={14} color="#f43f5e" />
          <span>MOCK DATA — V0</span>
        </div>
      </div>
    </header>
  );
};
